import t from 'react-translate';
import { css } from '@emotion/react';
import { almostBlack } from 'athena/styles/colors';
import { headerLineHeight } from 'styles/global_defaults/fonts';
import MatchingTypeSelector from './matching-type-selector';
import MatchingTypeConfiguration from './matching-type-configuration';
import { setSaveStatus, updateMentoringProgram } from 'redux/actions/mentoring-programs';
import { SaveStatus } from 'redux/schemas/app/mentoring-programs';
import { wrapThunkAction } from 'redux/utils';
import MentoringProgramContext from '../../context';
import { useContext } from 'react';
import { useAppDispatch } from 'redux/store';
import { FormProvider, useForm } from 'react-hook-form';

const styles = css`
  max-width: 820px;
  margin-left: auto;
  margin-right: auto;

  .description {
    color: ${almostBlack};
    line-height: ${headerLineHeight}px;
  }
`;

const MatchingSettings = () => {
  const dispatch = useAppDispatch();
  const { mentoringProgram } = useContext(MentoringProgramContext);
  const { id, matchingType } = mentoringProgram || {};
  const translationBase =
    t.MENTORING_PROGRAMS.SETTINGS.TABS.MATCHING_SETTINGS;

  const methods = useForm({
    defaultValues: {
      matchingType,
    },
  });

  const onSubmit = () => {
    const formData = methods.getValues();
    dispatch(setSaveStatus({ newStatus: SaveStatus.IN_PROGRESS }));
      wrapThunkAction(
        dispatch(
          updateMentoringProgram({
            id,
            autoMatchingEnabled: !!mentoringProgram.autoMatchingEnabled,
            maxMentees: mentoringProgram.concurrentMentorConnection,
            matchingType: formData.matchingType,
          })
        )
      )
        .then(() => {
          dispatch(setSaveStatus({ newStatus: SaveStatus.COMPLETED }));
        })
        .finally(() => {
          setTimeout(() => {
            dispatch(setSaveStatus({ newStatus: null }));
          }, 3000);
        });
  }

  return id ? (
    <FormProvider {...methods}>
      <div css={styles}>
        <div className='mb-4'>
          <div className='title heading-2 mb-2'>
            {translationBase.MATCHING_TITLE()}
          </div>
          <div className='description text-regular mb-6'>
            {translationBase.DESCRIPTION()}
          </div>
          <MatchingTypeSelector onSubmit={onSubmit} />
          <MatchingTypeConfiguration />
        </div>
      </div>
    </FormProvider>
  ) : null;
};

export default MatchingSettings;
